import { Util } from "@xt/xtbase";

const { getUrl, getXTUrl } = Util;

function withLocalePrefix(path, locale) {
  const normalizedPath = path?.startsWith("/") ? path : `/${path || ""}`;
  if (!locale || locale === "default") return normalizedPath;

  const [pathname, search = ""] = normalizedPath.split("?");
  const locales = Array.isArray(Util.nextI18nLocales) ? Util.nextI18nLocales.filter((item) => item && item !== "default") : [];
  const hasLocalePrefix = locales.some((item) => pathname === `/${item}` || pathname.startsWith(`/${item}/`));

  if (hasLocalePrefix) return normalizedPath;
  return `/${locale}${pathname === "/" ? "" : pathname}${search ? `?${search}` : ""}`;
}

function normalizeQueryValue(value) {
  if (value == null || value === "") return undefined;
  return String(value);
}

export function buildThirdPartyBuyPath(query = {}) {
  const params = new URLSearchParams();
  const mapping = {
    currency: normalizeQueryValue(query.currency),
    v: normalizeQueryValue(query.v),
    c: normalizeQueryValue(query.c),
    tradeType: normalizeQueryValue(query.tradeType),
    payMethodText: normalizeQueryValue(query.payMethodText),
  };

  Object.keys(mapping).forEach((key) => {
    if (mapping[key] != null) params.set(key, mapping[key]);
  });

  const search = params.toString();
  return `/credit/debitCard${search ? `?${search}` : ""}`;
}

export function getThirdPartyBuyUrl(query = {}, options = {}) {
  const path = buildThirdPartyBuyPath(query);
  const localizedPath = withLocalePrefix(path, options.locale);
  return options.absolute ? getXTUrl(localizedPath) : getUrl(localizedPath);
}

export function openThirdPartyBuy(query = {}, options = {}) {
  const href = getThirdPartyBuyUrl(query, options);
  if (typeof window !== "undefined") {
    window.location.href = href;
  }
  return href;
}
